<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <div v-if="isMobile()">
            <v-container>
                <v-row>
                    <v-card elevation="12" class="border" :height="`${98.5}%`"
                        style="position: absolute; width: 98%; margin-top: 1%; margin-left: 1%; margin-right: 1%; padding-bottom: 5%; border-radius: 9px;">
                        <p
                            style="margin-top: 15%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 20px; font-weight: 300;">
                            Bienvenido </p>
                        <img src="./../assets/images/Logo_calper_pequeño.png"
                            style="position: absolute; bottom: 50%; left: 20%;" />
                        <img src="./../assets/images/logo_FIISC_pequeño.png"
                            style="position: absolute; bottom: 5%; left: 30%;" width="134px" height="51px" />
                    </v-card>
                </v-row>
            </v-container>
        </div>
        <div v-else>
            <v-container>
                <v-row>
                    <v-card elevation="12" class="border" :height="`${95}%`"
                        style="position: absolute; width: 95%; margin-top: 1%; margin-left: 1%; margin-right: 1%; padding-bottom: 5%; border-radius: 9px;">
                        <img src="./../assets/images/Logo_calper_pequeño.png"
                            style="position: absolute; top: 10%; left: 45%;" />
                        <v-icon style="position: absolute; top: 45%; left: 50%" medium color="#3F616C">
                            error_outline</v-icon>
                        <p
                            style="position: absolute; top: 50%; left: calc(50% - 500px/2); font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 20px;">
                            Esta aplicación no es accesible desde un ordenador o tablet </p>
                        <p
                            style="position: absolute; top: 60%; left: calc(50% - 60px/2); font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px;">
                            Por favor,</p>
                        <p
                            style="position: absolute; top: 63%; left: calc(50% - 220px/2); font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px;">
                            acceda desde un teléfono móvil</p>
                        <img src="./../assets/images/logo_FIISC_pequeño.png"
                            style="position: absolute; bottom: 15%; left: 46%;" width="134px" height="51px" />
                    </v-card>
                </v-row>
            </v-container>
        </div>
    </v-main>
</template>

<script>
import axios from "axios";
import { preference } from "vue-preferences";
import { nextScreen } from '../router/utils.js';
const api = require('../../config/conf.env');

export default {
    name: 'Welcome',
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    },
    async mounted() {
        if (this.isMobile()) {
            // review to enter with qr code if max errors rediregt to max error screen
            const searchParams = new URLSearchParams(window.location.search);
            const urlToken = searchParams.get('token');
            if (urlToken != null) {
                console.log(urlToken);
                await axios.get(api.partialUrl + api.group, {
                    headers: { Authorization: `${urlToken}` }
                }).then((res) => {
                    console.log(res.data);
                    if (res.data.status == "max_errors") {
                        nextScreen(this.$router, '/maxerror');
                    } else {
                        const token = preference('apiToken', { defaultValue: '' });
                        token.set(urlToken);
                        nextScreen(this.$router, '/welcomeinfo');
                    }
                }).catch((error) => {
                    console.log(error);
                    nextScreen(this.$router, '/accesscodeerror');
                });
            } else {
                nextScreen(this.$router, '/accesscode');
            }
        }
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Welcome.vue